<template>
  <div>
  <user-menu />
    <div class="wrapper">
      <EnterpriseAdminSidebarMenu 
        :readOnly="isReadOnly"
      />
      <div class="content-wrapper ea-container">
        <div class="home-main-wrapper center mt-2">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <div class="jumbotron ea-jumbotron-box">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 row-split">
                  <div class="ea-card-title">
                    <h6>{{ accountItems.account_name }}</h6>
                  </div>
                  <div class="ea-card-body">
                    <div class="row text-center">
                      <div class="col-4 col-sm-4 col-md-4 col-lg-4">
                        <router-link to="/locations" class="text_decor_none">
                          <span class="ea-total-counts">{{ accountItems.totalMappedAccounts }}</span><br/>
                          <span class="ea-group-name">Locations</span>
                        </router-link>
                      </div>
                      <div class="col-4 col-sm-4 col-md-4 col-lg-4">
                        <span class="ea-total-counts">{{ accountItems.totalApprenticesCount }}</span><br/>
                        <span class="ea-group-name cursor_disable">Apprentices</span>
                      </div>
                      <div class="col-4 col-sm-4 col-md-4 col-lg-4">
                        <span class="ea-total-counts">{{ accountItems.totalMenteesCount }}</span><br/>
                        <span class="ea-group-name cursor_disable">Mentees</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="ea-quick-access-card">
                      <div class="ea-card-title">
                        <h6>Quick Access</h6>
                      </div>
                      <div class="ea-card-body">
                        <div v-if="isReadOnly">
                          <div class="row justify-content-end">
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                              <img src="@/assets/enterprise/Add_Enterprise_Admin_User_16x16.png" />
                              <a class="ea-quick-link cursor_disable">Add Enterprise Admin/User</a>
                            </div>
                            <div class="col-5 col-sm-5 col-md-5 col-lg-5">
                              <i class="fa fa-bar-chart-o"></i> <a class="ea-quick-link cursor_disable">Reports</a>
                            </div>
                          </div>
                          <div class="row justify-content-end" v-if="resources.length > 0">
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6" v-for="(resource, rindex) in resources" :key="rindex">
                              <img src="@/assets/enterprise/Resource_Book.png" />
                              <a @click="getResourceView(resource.filename)" class="ea-quick-link">{{ resource.name }}</a>
                            </div>
                            <div class="col-5 col-sm-5 col-md-5 col-lg-5">
                             
                            </div> 
                          </div>

                        </div>
                        <div v-else>
                          <div class="row justify-content-end">
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                              <img src="@/assets/enterprise/Add_Enterprise_Admin_User_16x16.png" />
                              <a class="ea-quick-link">Add Enterprise Admin/User</a>
                            </div>
                            <div class="col-5 col-sm-5 col-md-5 col-lg-5">
                              <img src="@/assets/enterprise/Renew_Subscription_16x16.png" />
-                              <a class="ea-quick-link" @click="openRenewModal">Renew Subscription(s)</a>
                            </div>
                          </div>
                          <div class="row justify-content-end">
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                              <img src="@/assets/enterprise/Add_New_Location.png" />
                              <a @click="openNewLocation" class="ea-quick-link">Add New Location</a>
                            </div>
                            <div class="col-5 col-sm-5 col-md-5 col-lg-5">
                              <img src="@/assets/enterprise/Add_User_to_Location_16x16.png" />
                              <a @click="openAddNewUserToLocation" class="ea-quick-link">Add User to Location</a>
                            </div>
                          </div>
                        
                          <div class="row justify-content-end" v-if="resources.length > 0">
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6" v-for="(resource, rindex) in resources" :key="rindex">
                              <img src="@/assets/enterprise/Resource_Book.png" />
                              <a @click="getResourceView(resource.filename)" class="ea-quick-link">{{ resource.name }}</a>
                            </div>
                            <div class="col-5 col-sm-5 col-md-5 col-lg-5">
                             
                            </div> 
                          </div>

                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- competency & reports box start -->
            <div class="row ea-row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="ea-card-box">
                  <div class="d-flex flex-row bd-highlight">
                    <div class="p-3 font-weight-bold">Competency Comparison</div>
                    <div class="p-3 flex-grow-1 bd-highlight">
                      <!--<a class="view-full-report">View Full Report</a>-->
                    </div>
                    <div class="ea-filter-dropdown">
                      <select class="form-control-sm" @change="getCompetencyComparison" v-model="competency_comparison">
                        <option value="60">60 Days</option>
                        <option value="90">90 Days</option>
                        <option value="180">6 Months</option>
                        <option value="365">1 Year</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 mb-4">
                    <div class="comp_heading_1">#</div>
                    <div class="comp_heading_2">Location</div>
                    <div class="comp_heading_3">Reps Recorded</div>
                    <div class="comp_heading_4">Competencies Earned</div>
                    <div class="clearfix"></div>
                    <div v-show="comp_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                    <div v-if="competencyComparisonCount > 0">
                      <div v-for="(item, index) in accountItems.competencyComparison" :key="index">
                        <div v-if="index == 0 && (item.reps_recorded > 0 || item.competencies_earned > 0) && !isReadOnly" class="comp_content_1">
                          <img src="@/assets/enterprise/Required_Gold_Batch_image_45X45.png" />
                        </div>
                        <div v-else class="comp_content_1">{{ (index+1) }}</div>
                        <div class="comp_content_2"><a @click="openSidebar(item.id)" class="ea-quick-link"> {{ item.org_name }} </a></div>
                        <div class="comp_content_3">{{ item.reps_recorded }}</div>
                        <div class="comp_content_4">{{ item.competencies_earned }}</div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                    <div v-else class="text-red text-center m-4">{{ getNoRecordText(competencyComparisonCount) }}</div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="ea-card-box">
                  <div class="d-flex flex-row bd-highlight">
                    <div class="p-3 font-weight-bold">Reports</div>
                    <div class="p-3 flex-grow-1 bd-highlight">
                    <!-- <a class="view-full-report">See All</a> -->
                    </div>
                    
                  </div>
                  <div class="col-12 ea-reports">
                    <div class="ea-reports-border">
                      <div class="report_heading_1">Competency Report</div>
                      <div class="report_heading_2"><a class="btn btn-primary btn-sm btn-view-report" @click="goToCompetencyReport">View Report</a></div>
                      <div class="clearfix"></div>
                    </div>
                    <div style="clear: both;"></div>
                    <div class="ea-reports-border">
                      <div class="report_heading_1">Usage Report</div>
                      <div class="report_heading_2"><a class="btn btn-primary btn-sm btn-view-report" @click="goToUsageReport">View Report</a></div>
                      <div class="clearfix"></div>
                    </div>
                    <div style="clear: both;"></div>
                    <div class="ea-reports-border">
                      <div class="report_heading_1">Rep Audit Trail</div>
                      <div class="report_heading_2"><a class="btn btn-primary btn-sm btn-view-report" @click="goToAuditReport">View Report</a></div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- competency & reports box end -->

            <!-- activity & earned box end -->
            <div class="row ea-row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="ea-chart-box">
                  <div class="d-flex flex-row bd-highlight">
                    <div class="col-5 p-3 font-weight-bold">Activity Over Time</div>
                    <div class="col-4 ea-filter-dropdown text-align-right" style="float-left;">
                      <select class="form-control-sm" v-model="select_activity_location" style="width: 100%;" @change="onChangeLocationActivityOverTime($event);">
                        <option value="">All Locations</option>
                        <option v-for="(item, index) in report_all_locations" :key="index" :value="item.id">{{ item.company_name }}</option>
                      </select>
                    </div>
                    <div class="col-3 ea-filter-dropdown text-align-right" style="float:right; padding-left: 0 !important;">
                      <select style="width:100%;" class="form-control-sm" @change="onChangeMonthActivityOverTime($event);">
                        <option value="6">6 Months</option>
                        <option value="9">9 Months</option>
                        <option value="12">12 Months</option>
                      </select>
                    </div>

                  </div>
                  <div style="width: 100%; margin: 0 0.8rem;" id="myChartDiv">
                    <canvas id="myChart" width="400" :height="height" ></canvas>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="ea-chart-box">
                  <div class="d-flex flex-row bd-highlight">
                    <div class="col-5 p-3 font-weight-bold">Earned Competencies</div>
                    <div class="col-4 ea-filter-dropdown text-align-right" style="float-left;">
                      <select class="form-control-sm" v-model="select_earned_location" style="width: 100%;" @change="onChangeLocationEarnedCompetencies($event);">
                        <option value="">All Locations</option>
                        <option v-for="(item, index) in report_all_locations" :key="index" :value="item.id">{{ item.company_name }}</option>
                      </select>
                    </div>

                    <div class="col-3 ea-filter-dropdown text-align-right" style="padding-left: 0!important; float: right;">
                      <select class="form-control-sm" @change="onChangeMonthEarnedCompetencies($event);" style="width: 100%;">
                        <option value="6">6 Months</option>
                        <option value="9">9 Months</option>
                        <option value="12">12 Months</option>
                      </select>
                    </div>
                  </div>
                  <div style="width: 100%; margin: 0 0.8rem;" id="myChartDiv2">
                    <canvas id="myChart2" width="400" :height="height" ></canvas>
                  </div>
                </div>
              </div>
            </div>
            <!-- activity & earned box end -->

            <EnterpriseAdminOverlaySidebar
              :isModalVisible="isModalVisible" 
              @close="closeSidebar"
              ref="location_sidebar" 
              :readOnly="isReadOnly" 
             />

             <AddNewLocation v-if="!isReadOnly"
              :isModalLocationVisible="isModalNewLocationVisible" 
              :accountId="defaultLocationId"
              @close="closeNewLocationSidebar"
              ref="add_new_location" 
             />

             <EnterpriseAdminRenewSubscription
              :isEnterpriseAdminRenewSubscriptionModalVisible="isEnterpriseAdminRenewSubscriptionModalVisible" 
              :accountId="accountItems.id"
              @close="closeEnterpriseAdminRenewSubscription"
              ref="enterprise_admin_renew_subscription_modal" 
             />

             <AddNewUserToLocation
                :isAddNewUserToLocationModalVisible="isAddNewUserToLocationModalVisible"
                ref="add_new_user_form_to_location"
                user_type=""
                user_role=""
                @close="closeAddNewUserToLocation"
             />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import router from '../../router/index.js';
import store from '../../store/store.js';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import Chart from 'chart.js';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';
import AddNewLocation from './add_new_location.vue';
import EnterpriseAdminRenewSubscription from './enterpriseadmin_renew_subscription.vue';
import AddNewUserToLocation from './add_new_user_to_location.vue';

export default {
  data() {
    return {
      comp_loading: false,
      isModalVisible: false,
      accountItems: { 
        account_name: '',
        totalMappedAccounts: 0,
        totalMenteesCount: 0,
        totalApprenticesCount: 0,
        competencyComparison: [],
        activityBarValues: [],
        activityBarLabels: [],
        activityBarMaxValues: '',
        activityBarStepSize: '',
        earnedBarValues: [],
        earnedBarLabels: [],
        earnedBarMaxValues: '',
        earnedBarStepSize: '',
      },
      reports: [
        { name: 'Competency Report' },
        // { name: 'Location Activity Report' },
        // { name: 'Demographics Report' },
        // { name: 'DQL Application Report' },
        // { name: 'Forms Report' },
      ],
      height: 300,
      competency_comparison: 60,
      select_report_location: '',
      report_all_locations: [],
      isModalNewLocationVisible: false,
      defaultLocationId: '',
      isEnterpriseAdminRenewSubscriptionModalVisible: false,
      competencyComparisonCount: 0,
      isRepsReceived: false,
      isAddNewUserToLocationModalVisible: false,
      earned_month_limit: 6,
      activity_month_limit:6,
      select_earned_location: '',
      select_activity_location: '',
      resources: []
    }    
  },
  computed: {
    isReadOnly(){
      if (this.$store.state.enterprise_type === 'Readonly') {
        return true;
      } else {
        if (this.$store.state.switch_admin_enterprise_isreadonly) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  components: {
    UserMenu,
    EnterpriseAdminSidebarMenu,
    EnterpriseAdminOverlaySidebar,
    AddNewLocation,
    EnterpriseAdminRenewSubscription,
    AddNewUserToLocation,
  },
  methods: {
    getCompetencyComparison(){
      var days_limit = this.competency_comparison;
      this.comp_loading = true;
      this.accountItems.competencyComparison = [];
      this.competencyComparisonCount = 0;
      this.isRepsReceived = false;
      axios('/enterprise-admin/get-competency-comparison',
        {
          method: 'GET',
          params: {
            account_id: this.accountItems.id,
            days: days_limit,
          }
        })
        .then(resp => {
          this.comp_loading = false;
          this.accountItems.competencyComparison = resp.data;
          this.competencyComparisonCount = resp.data.length;
          this.isRepsReceived = true;
      })
        .catch(() => {
      });
    },
    onChangeLocationEarnedCompetencies(event) {
      this.select_earned_location = event.target.value;
      this.getEarnedCompetencies();
    },
    onChangeLocationActivityOverTime(event) {
      this.select_activity_location = event.target.value;
      this.getActivityOverTime();
    },
    onChangeMonthActivityOverTime(event) {
      this.activity_month_limit = event.target.value;
      this.getActivityOverTime();
    },
    onChangeMonthEarnedCompetencies(event) {
      this.earned_month_limit = event.target.value;
      this.getEarnedCompetencies();
    },
    getActivityOverTime() {
      axios('/enterprise-admin/get-activity-over-time',
        {
          method: 'GET',
          params: {
            account_id: this.accountItems.id,
            month: this.activity_month_limit,
            location: this.select_activity_location,
          }
        })
        .then(resp => {
          this.accountItems.activityBarValues = resp.data.activityBarValues;
          this.accountItems.activityBarLabels = resp.data.activityBarLabels;
          this.accountItems.activityBarMaxValues = resp.data.activityBarMaxValues;
          this.accountItems.activityBarStepSize = resp.data.activityBarStepSize;
          this.initActivityOverTimeGraph();
        })
        .catch(() => {
        });
    },




    getEarnedCompetencies() {
      axios('/enterprise-admin/get-earned-competencies',
        {
          method: 'GET',
          params: {
            account_id: this.accountItems.id,
            month: this.earned_month_limit,
            location: this.select_earned_location,
          }
        })
        .then(resp => {
          this.accountItems.earnedBarValues = resp.data.earnedBarValues;
          this.accountItems.earnedBarLabels = resp.data.earnedBarLabels;
          this.accountItems.earnedBarMaxValues = resp.data.earnedBarMaxValues;
          this.accountItems.earnedBarStepSize = resp.data.earnedBarStepSize;
          this.initEarnedCompetenciesGraph();
        })
        .catch(() => {
        });
    },
    initActivityOverTimeGraph() {
      var ctx = document.getElementById('myChart');
      const data = {
        labels: this.accountItems.activityBarLabels,
        datasets: [{
          label: '',
          data: this.accountItems.activityBarValues,
          fill: false,
          borderColor: 'rgb(0, 172, 238)',
          backgroundColor: 'rgb(255, 255, 255)',
          tension: 0.1,
          borderWidth: 3,
          borderRadius: 5,
          pointBorderWidth: 2,
          borderSkipped: false,
        }]
      };
      var myChart = new Chart(ctx, {
        type: 'line',
        data: data,
        options: {
          indexAxis: 'y',
          elements: {
            bar: {
              borderWidth: 1,
            }
          },
          title: {
              display: false,
          },
          layout: {
            padding: {
              left: 0,
              right: 60,
              top: 15,
              bottom: 0
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          events: [],
          scales: {
            xAxes: [{
                gridLines: {
                  drawOnChartArea:false,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Months'
                }
            }],
            yAxes: [{
              ticks: {
                  beginAtZero: true,
                  max: this.accountItems.activityBarMaxValues,
                  min: 0,
                  stepSize: this.accountItems.activityBarStepSize,
                  callback: function(value,   index, values) {
                    return value;
                  },
              },
              barThickness: 1,
              categoryPercentage: 1.0,
              gridLines: {
                drawOnChartArea:false,
              },
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'Reps'
              }
            }],
          },
        }
      });
    },
    initEarnedCompetenciesGraph() {
      var ctx2 = document.getElementById('myChart2');
      const data2 = {
        labels: this.accountItems.earnedBarLabels,
        datasets: [{
          label: '',
          data: this.accountItems.earnedBarValues,
          fill: false,
          borderColor: 'rgb(0, 172, 238)',
          backgroundColor: 'rgb(255, 255, 255)',
          tension: 0.1,
          borderWidth: 3,
          borderRadius: 5,
          pointBorderWidth: 2,
          borderSkipped: false,
        }]
      };

      var myChart = new Chart(ctx2, {
        type: 'line',
        data: data2,
        options: {
          indexAxis: 'y',
          elements: {
            bar: {
              borderWidth: 1,
            }
          },
          title: {
              display: false,
          },
          layout: {
            padding: {
              left: 0,
              right: 60,
              top: 15,
              bottom: 0
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          events: [],
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Months'
              },
              gridLines: {
                drawOnChartArea:false,
              }
            }],
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    max: this.accountItems.earnedBarMaxValues,
                    min: 0,
                    stepSize: this.accountItems.earnedBarStepSize,
                    callback: function(value,   index, values) {
                      return value;
                    },
                },
                gridLines: {
                  drawOnChartArea:false,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Reps'
                },
            }],
          },
        }
      });
    },
    openSidebar(accountId) {
      this.isModalVisible = true;
      this.$refs.location_sidebar.getLocationDetail(accountId);
    },
    closeSidebar() {
      this.isModalVisible = false;
      this.$refs.location_sidebar.selectedComponent = 'OverviewTab';
    },
    goToAuditReport() {
      router.push('/enterprise-admin/rep-audit-trail/All?dhb=1')
    },
    goToCompetencyReport() {
      router.push('/enterprise-admin/competency-report-overview/All?dhb=1')
    },
    goToUsageReport() {
      router.push('/enterprise-admin/usage_report')
    },
    openNewLocation() {
      this.isModalNewLocationVisible = true;
      this.$refs.add_new_location.close_url = 'enterprise_admin_dashboard';
      this.$refs.add_new_location.loadInitialData();
    },
    closeNewLocationSidebar() {
      this.isModalNewLocationVisible = false;
    },
    openMoveUser() {
      this.isModalVisible = true;
      this.$refs.location_sidebar.selectedComponent = 'UsersTab';
      this.$refs.location_sidebar.getLocationDetail(this.defaultLocationId);
    },
    openAddNewUserToLocation() {
      this.isAddNewUserToLocationModalVisible = true;
      this.$refs.add_new_user_form_to_location.getLocations();
    },
    closeAddNewUserToLocation() {
      this.isAddNewUserToLocationModalVisible = false;
    },
    openRenewModal() {
      this.isEnterpriseAdminRenewSubscriptionModalVisible = true;
      this.accountId = this.accountItems.id;
      this.$refs.enterprise_admin_renew_subscription_modal.loadInitialData();
    },
    closeEnterpriseAdminRenewSubscription() {
      this.isEnterpriseAdminRenewSubscriptionModalVisible = false;
    },
    getNoRecordText(count) {
        if (this.loading) {
            return '';
        } else {
            if (count == 0 && this.isRepsReceived) {
                return 'No Location found with Reps Recorded';
            }
        }
    },
    getResourceView(fileLink) {
      window.open(fileLink, '_blank');
    } 
  },
  created() {
    
    axios('/enterprise-admin-info',
    {
        method: 'GET',
    })
    .then(resp => {
      this.accountItems = resp.data.account;
      this.defaultLocationId = this.accountItems.id;
      //console.log(this.accountItems)
      if (this.accountItems.length == 0) {
        this.isRepsReceived = true;
      }
      setTimeout(() => {
        
        this.initActivityOverTimeGraph();

        this.initEarnedCompetenciesGraph();

        this.getCompetencyComparison();

      }, 3000);
    })
    .catch(() => {
    });

    axios('/enterprise-admin/getAllLinkedLocations',
    {
        method: 'GET'
    })
    .then(response => {
        this.loading = false;
        this.report_all_locations = response.data.locations;
        if (this.report_all_locations.length > 0) {
          this.select_report_location = this.report_all_locations[0].id;
        }
    })
    .catch(() => {
    });

     var role = 'ROLE_ENTERPRISE_ADMIN'; 
     axios.get('/desktop/user/resource-lists', {
           params: {
           user_roles: role,
           accountId: ''
          }
     })
     .then(response =>  {
          this.resources = response.data;
        })
     .catch(function() {
          
     });    

  },
}
</script>
<style scoped>
.ea-container { font-size: 13px !important; }
.ea-jumbotron-box {
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  padding: 2rem;
  margin-bottom: 1rem;
}
.ea-row { margin-bottom: 0.5rem; }
.ea-card-box {
  background-color: #FFF !important;
  min-height: 21rem;
  margin-bottom: 0.5rem;
  border-radius: 0.3rem;
}
.ea-chart-box {
  background-color: #FFF !important;
  border-top: 4px solid #00acee !important;
  min-height: 16rem;
  margin-bottom: 0.5rem;
}
.ea-card-title h6 { 
  font-weight: 900 !important;
  margin-bottom: 1rem;
}
.ea-total-counts {
  font-weight: 900;
  font-size: 3em;
  color: #00acee;
}
.ea-card-body .row {
  margin-top: 1rem;
}
.ea-group-name, .ea-quick-link {
  text-decoration: underline !important;
  cursor:pointer;
}
.view-full-report {
  font-size: 12px;
  text-decoration: underline !important;
  color: #00acee !important;
  cursor: pointer;
}
.ea-filter-dropdown { 
  padding: 0.5rem 1.25rem;  
}
.ea-filter-dropdown select {
  background-color: #FFF;  
}
.ea-filter-dropdown select:focus-visible {
  outline: none;
}
.comp_heading_1 { width: 10%; float: left; padding: 8px 3px; font-weight: 900; font-size: 13px; text-align: center; }
.comp_heading_2 { width: 35%; float: left; padding: 8px 3px; font-weight: 900; font-size: 13px; }
.comp_heading_3 { width: 22%; float: left; padding: 8px 3px; font-weight: 900; font-size: 13px; text-align: center; }
.comp_heading_4 { width: 33%; float: left; padding: 8px 3px; font-weight: 900; font-size: 13px; text-align: center; }
.comp_content_1 { width: 10%; float: left; padding: 8px 3px; font-weight: 900; text-align: center; }
.comp_content_2 { width: 35%; float: left; padding: 8px 3px; text-align: left; }
.comp_content_3 { width: 22%; float: left; padding: 8px 3px; text-align: center; }
.comp_content_4 { width: 33%; float: left; padding: 8px 3px; text-align: center; }
.report_heading_1 { width: 70%; float: left; text-align: left; }
.report_heading_2 { width: 30%; float: left; text-align: right; }
.ea-reports { margin: 0 0.8rem; }
.ea-reports-border { border-bottom: 0px solid #CCC; width: 95%; margin: 5px 0 5px 0; }
.ea-reports-border:nth-last-child(1) { border-bottom: 0 none; }
.btn-view-report {
  color: #FFF !important;
  background-color: #00acee;
  border: 1px solid #00acee;
  border-radius: 8px;
  font-size: 13px;
  padding: 8px;
  line-height: 8px;
  margin: 5px;
  cursor: pointer;
}
.btn-view-report:active, .btn-view-report:focus {
  color: #FFF !important;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
} 
.text_decor_none { text-decoration: none; color: #002F42 !important; }
/* Extra Large Devices */
@media (min-width: 1200px) {
  .row-split { border-right: 1px solid #00acee !important; }
  .ea-quick-access-card { margin-left: 2rem; }
}
/* Large Devices */
@media (min-width: 809px) and (max-width: 1024px) { 
  .row-split { border-right: 1px solid #00acee !important; }
  .ea-quick-access-card { margin-left: 2rem; }
}
/* Medium Devices */
@media (min-width: 601px) and (max-width: 768px) { 
  .row-split { margin-bottom: 1rem; }
  .btn-view-report { font-size: 11px !important; }
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 576px) { 
  .row-split { margin-bottom: 1rem; }
  .btn-view-report { font-size: 11px !important; }
}
.cursor_disable { cursor: none !important; }
.report_location_dd { width: 290px; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterprise_admin_dashboard.vue